// Image-grid slider enhancement (inventory 3.9). The track scrolls
// natively with CSS scroll-snap and stays keyboard-scrollable without
// JavaScript; this script only wires the prev/next buttons and the
// position indicator on top of the scroll gesture. Multi-instance via
// [data-th-gallery]. React twin: components/image-grid/ImageGrid.tsx.
function initGallery(): void {
  document.querySelectorAll<HTMLElement>('[data-th-gallery]').forEach((gallery) => {
    const track = gallery.querySelector<HTMLElement>('.th-gallery__track');
    const prev = gallery.querySelector<HTMLButtonElement>('[data-gallery-prev]');
    const next = gallery.querySelector<HTMLButtonElement>('[data-gallery-next]');
    const pos = gallery.querySelector<HTMLElement>('[data-gallery-pos]');
    if (!track || !prev || !next || !pos) {
      return;
    }
    const figures = Array.from(track.querySelectorAll<HTMLElement>('.th-gfig'));
    const total = figures.length;

    function currentIndex(): number {
      const left = track!.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      figures.forEach((figure, i) => {
        const dist = Math.abs(figure.offsetLeft - track!.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function update(): void {
      const i = currentIndex();
      pos!.textContent = `${i + 1}/${total}`;
      const atStart = i <= 0;
      const atEnd = i >= total - 1;
      // A button that gets disabled while focused would drop the focus to
      // the body (WCAG 2.4.3): hand it to the other button first
      if ((atStart && document.activeElement === prev) || (atEnd && document.activeElement === next)) {
        (atStart ? next : prev)!.focus();
      }
      prev!.disabled = atStart;
      next!.disabled = atEnd;
    }

    function goTo(target: number): void {
      const clamped = Math.max(0, Math.min(total - 1, target));
      track!.scrollTo({ left: figures[clamped].offsetLeft - track!.offsetLeft });
    }

    prev.addEventListener('click', () => goTo(currentIndex() - 1));
    next.addEventListener('click', () => goTo(currentIndex() + 1));

    let raf = 0;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      },
      { passive: true },
    );
    window.addEventListener('resize', update);
    update();
  });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initGallery) : initGallery();
